export enum AvatarSize {
  card_attending = 'card_attending',
  fill_m = 'fill-m',
  fill_l = 'fill-l',
}
